module.exports = __webpack_public_path__ + "img/9788946061989.94d72d6d.jpg";